import React from 'react';

import PropTypes from 'prop-types';

import { GetOnClick } from './helpers';

import ml from '@src/css/metlife_css/buttons.scss';


/**
 * ## StandardLink
 *
 * Standard link with MetLife UX Styles
 * @param {object} appHistory - Redux app history - or - push function
 * @param {function} pushHistory - Function passed down appHistory.push()
 * Used to when Component alter history before it is pushed.
 * @param {string} text - display text string
 * @param {string} link - href string
 * @param {string} modifyAppHistoryLink - Modify the directory that appHistory pushed to
 * @param {boolean} External - If true this is an external links
 */

export const StandardLink = (props) => {
    const {
        appHistory,
        text,
        link,
        pushHistory,
        modifyAppHistoryLink = '/',
        External = false,
    } = props;

    // If appHistory exist and it includes
    if (pushHistory || appHistory) {
        return (
            <a
                href="#"
                className={ml['ml-link']}
                 
                onClick={GetOnClick.bind(this, {
                    appHistory,
                    link,
                    pushHistory,
                    modifyAppHistoryLink,
                })}
            >
                {text}
            </a>
        );
    }

    // If not appHistory is set and External is true
    if (External) {
        return (
            <a
                className={ml['ml-link']}
                target="_blank"
                rel="noopener noreferrer"
                href={link}
            >
                {text}
            </a>
        );
    }

    // Else the page will push history but refresh page requesting
    // all the script pages again
    return (
        <a
            className={ml['ml-link']}
            href={`${modifyAppHistoryLink}${link}`}
        >
            {text}
        </a>
    );
};

StandardLink.propTypes = {
    appHistory: PropTypes.object,
    text: PropTypes.string,
    link: PropTypes.string,
    pushHistory: PropTypes.func,
    modifyAppHistoryLink: PropTypes.func,
    External: PropTypes.bool,
};
